import React from 'react';
import RowButtons from '../RowButtons/RowButtons';
import { unvisibleButton } from '../../util/unvisibleButton';
import transLoader from '@beisen/i18n-translation-loader';
require('./SyncRowHandler.scss');

const defaultTranslation = {
    more: '更多'
};
class SyncRowHandler extends React.Component {
    constructor(props) {
        super(props);
        this.touchGroupContainer = this.touchGroupContainer.bind(this);
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            more: 'common.more'
        }), props.translation);

	}

    touchGroupContainer(e) {
        e.stopPropagation();
    }

    rowButtonItemTouchHandler(button, index) {
        this.props.rowButtonItemTouchTap &&
            this.props.rowButtonItemTouchTap(button, index);
    }

    /**
     * 根据设置的count返回按钮数组
     * @param {array} useableButtons - 按钮list
     * @param {number} count - 控制显示行按钮的数量
     */
    returnRowButtonList(useableButtons, count) {
		let _rowButtonComponentList = [];
		for(let i = 0; i < count; i++) {
			_rowButtonComponentList.push(<RowButtons buttonId={useableButtons[i]['cmp_id']} partId={this.props.partId} text={useableButtons[i]['cmp_data']['title']} cls={useableButtons[i]['cmp_data']['outstand'] == 'true' ? 'outstand' : ''} onTouchTap={this.rowButtonItemTouchHandler.bind(this,useableButtons[i])}></RowButtons>);
		  }
		return _rowButtonComponentList;
	}
	/**
	 * 对于按钮list超过3个的情况，展示前两个，显示“更多” 按钮
	 * @param {array} useableButtons - 按钮list
	 */
    showMore(useableButtons) {
		let _rowButtonComponentList = this.returnRowButtonList(useableButtons,2);
		    _rowButtonComponentList.push(<RowButtons text={this.translation.more} cls='more' onTouchTap={this.rowButtonItemTouchHandler.bind(this,null)}></RowButtons>);
		return _rowButtonComponentList;
	}
	render() {
		let { hasRowHandler, rowButtonList } = this.props;
        let rowButtonComponentList = [];
		const useableButtons = rowButtonList ? rowButtonList.filter(item => item.cmp_data.visible && !item.cmp_data.disable && !unvisibleButton(item.cmp_data.action)) : [];
		if(!useableButtons || useableButtons.length === 0 || !hasRowHandler) {
			return null;
		}
            rowButtonComponentList = useableButtons ?  (useableButtons.length > 3 ? this.showMore(useableButtons) : this.returnRowButtonList(useableButtons,useableButtons.length)) : [];
		if(rowButtonComponentList.length > 0) {
		    return (<div className='rowbuttongroup clearfix' onTouchTap={this.touchGroupContainer}>
					{rowButtonComponentList}
					<span className='groupline'></span>
                </div>);
        }
        return null;
    }
}

export default SyncRowHandler;



// WEBPACK FOOTER //
// ./src/components/TableColumns/SyncRowHandler/SyncRowHandler.js